<template>
    <div>
        <h2 class="text-2xl pb-6">
            Add your fax number to our "Do Not Call/Fax" list
        </h2>

        <p>
            We understand that not everyone wants to be contacted by fax. Please
            enter your fax number below to prevent faxes being sent to your
            number.
        </p>

        <ValidationObserver v-slot="{ invalid, reset }">
            <form
                action="/remove-fax-number"
                method="post"
                @submit.prevent="requestFaxRemoval"
                @reset.prevent="reset"
            >
                <label for="faxnumber" class="text-gray-700"
                    >Enter Your Fax Number</label
                >
                <ValidationProvider
                    :rules="{ regex: /^\([0-9]{3}\)\s[0-9]{3}\-[0-9]{4}$/ }"
                    v-slot="{ errors }"
                >
                    <input
                        class="form-input block mb-3"
                        type="text"
                        maxlength="14"
                        name="faxnumber"
                        v-model="faxnumber"
                        placeholder="(123) 123-1233"
                        required
                    />
                    <span class="block text-sm text-red-400 mb-2 h-6">{{
                        errors[0]
                    }}</span>
                </ValidationProvider>
                <input
                    class="btn btn-green"
                    type="submit"
                    :disabled="invalid || submitmessage"
                    value="Yes, please remove this number."
                />
            </form>
        </ValidationObserver>

        <div v-if="submitmessage" class="mt-6">
            <p class="text-green-500 font-bold">{{ submitmessage }}</p>
        </div>
    </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { ValidationObserver } from "vee-validate";

import { extend } from "vee-validate";
import { required, regex } from "vee-validate/dist/rules";

extend("required", {
    ...required,
    message: "Please enter your Fax Number."
});
extend("regex", {
    ...regex,
    message: "Please use the format: (123) 123-1233"
});

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            faxnumber: null,
            submitmessage: null
        };
    },
    methods: {
        requestFaxRemoval() {
            let url = "/remove-fax-number";
            let data = { faxnumber: this.faxnumber };
            axios
                .post(url, data)
                .then(result => {
                    console.log(result.data);
                    if (result.data.message === "success") {
                        this.faxnumber = null;
                        this.submitmessage =
                            "Your number has been added to the DNC list. Please allow up to 30 days for our system to update.";
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
};
</script>

<style scoped></style>
